import React from 'react';
import { observer } from '../../../shared/observer';

// Выбор адреса для чекаута. Радио-список существующих адресов + кнопка
// «Добавить адрес». Порт мобильного `client_app/.../Cart/Checkout/index.tsx`
// (строки 313–342): TouchableOpacity на каждом адресе + RadioButton слева.
class AddressPickerView extends React.Component {
  state = { loading: false };

  componentDidMount() {
    if (this.props.auth.isAuthenticated) {
      this.setState({ loading: true });
      // Ошибку глотаем: список просто не появится, кнопка «Добавить адрес»
      // останется доступной.
      this.props.address.getAddresses()
        .catch(() => {})
        .then(() => this.setState({ loading: false }));
    }
  }

  pickAddress = (addr) => () => {
    if (!addr || !addr.id) return;
    // address: { id } — обязательно, иначе backend на update_common_params
    // зовёт set_address(nil) и обнуляет address_model + district_id.
    // См. mobile-аналог: client_app/.../Cart/Checkout/index.tsx:319.
    this.props.order.setFieldsToUpdateOrder({
      address_id: addr.id,
      address: { id: addr.id },
      district_id: addr.district_id,
    });
    if (addr.district_id) {
      this.props.order.setSelectedAddressDistrictId(addr.district_id);
    }
  };

  openAddDialog = () => {
    this.props.address.openAddDialog((newAddress) => {
      if (!newAddress) return;
      this.props.order.setFieldsToUpdateOrder({
        address_id: newAddress.id,
        address: { id: newAddress.id },
        district_id: newAddress.district_id,
      });
      if (newAddress.district_id) {
        this.props.order.setSelectedAddressDistrictId(newAddress.district_id);
      }
    });
  };

  formatAddress(a) {
    return a.map_addr
      || a.full_addr_with_city
      || a.full_addr
      || [a.city, a.street, a.dom].filter(Boolean).join(', ').trim();
  }

  render() {
    const addresses = this.props.address.addresses || [];
    const fields = this.props.order.fieldsToUpdateOrder;
    const auth = this.props.auth;
    const ci = auth.clientInfo || {};
    const allowNew = ci.is_allow_new_address !== false; // default true для старых компаний

    if (!auth.isAuthenticated) {
      return (
        <section className="ng-checkout__section">
          <label>Адрес доставки</label>
          <p className="ng-checkout__hint">Войдите в аккаунт, чтобы выбрать или добавить адрес доставки.</p>
        </section>
      );
    }

    return (
      <section className="ng-checkout__section">
        <label>Адрес доставки</label>

        {this.state.loading && (
          <span className="ng-loading-hint">Загружаем адреса…</span>
        )}

        {!this.state.loading && addresses.length > 0 && (
          <div className="ng-address-list">
            {addresses.map((a) => {
              const active = fields.address_id === a.id;
              return (
                <button
                  key={a.id}
                  type="button"
                  className={'ng-address-row' + (active ? ' ng-address-row--active' : '')}
                  onClick={this.pickAddress(a)}
                >
                  <span className={'ng-radio' + (active ? ' ng-radio--active' : '')} aria-hidden="true" />
                  <span className="ng-address-row__text">{this.formatAddress(a)}</span>
                </button>
              );
            })}
          </div>
        )}

        {!this.state.loading && allowNew && (
          <button
            type="button"
            className={'ng-address-add' + (addresses.length > 0 ? ' ng-address-add--with-sep' : '')}
            onClick={this.openAddDialog}
          >
            <span className="ng-address-add__plus" aria-hidden="true">+</span>
            <span>Добавить адрес</span>
          </button>
        )}
      </section>
    );
  }
}

export const AddressPicker = observer(AddressPickerView, ['addressStore', 'orderStore', 'authStore']);



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/components/Cart/Checkout/AddressPicker.jsx